import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconMoneyGreen = createIcon({
  path: (
    <>
      <path
        d="M5.52881 10.3143C5.52881 8.54694 6.9615 7.11426 8.72881 7.11426H17.9574C19.6142 7.11426 20.9574 8.4574 20.9574 10.1143V13.8C20.9574 15.4568 19.6142 16.8 17.9574 16.8H8.12881C6.69287 16.8 5.52881 15.6359 5.52881 14.2V10.3143Z"
        fill="#D8EDEB"
      />
      <rect
        x="1.71436"
        y="6"
        width="7.88571"
        height="2.31429"
        rx="1.15714"
        fill="#2B897C"
      />
      <rect
        x="1.71436"
        y="10.7998"
        width="6.51429"
        height="2.31429"
        rx="1.15714"
        fill="#2B897C"
      />
      <rect
        x="1.71436"
        y="15.6855"
        width="4.71429"
        height="2.31429"
        rx="1.15714"
        fill="#2B897C"
      />
      <ellipse
        cx="13.7581"
        cy="11.9138"
        rx="1.97143"
        ry="1.97143"
        fill="#2B897C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8296 7.11417C10.8296 6.4751 11.3476 5.95703 11.9867 5.95703H18.9003C20.7702 5.95703 22.2861 7.47287 22.2861 9.34275V14.5713C22.2861 16.4412 20.7702 17.957 18.9003 17.957H8.8715C8.23243 17.957 7.71436 17.439 7.71436 16.7999C7.71436 16.1608 8.23243 15.6427 8.8715 15.6427H18.9003C19.4921 15.6427 19.9718 15.163 19.9718 14.5713V9.34275C19.9718 8.75101 19.4921 8.27132 18.9003 8.27132H11.9867C11.3476 8.27132 10.8296 7.75325 10.8296 7.11417Z"
        fill="#2B897C"
      />
    </>
  ),
});

export default IconMoneyGreen;
